import { useQuery } from '@tanstack/react-query';
import type AdminApiAdminImportRequest from '@/types/serializers/AdminApiAdminImportRequest';

// APIレスポンスはオブジェクト直接 or { data: ... } でラップされた形のどちらかを想定
type AdminImportRequestResponse =
  | AdminApiAdminImportRequest
  | {
      data?: AdminApiAdminImportRequest;
    };

const normalizeImportRequest = (
  payload: AdminImportRequestResponse
): AdminApiAdminImportRequest | null => {
  if ('id' in payload) {
    return payload;
  }
  return payload.data ?? null;
};

export default function useFetchAdminImportRequest(id: number | null) {
  return useQuery({
    queryKey: ['admin', 'import_requests', id],
    queryFn: async () => {
      if (!id) return null;
      const response = await fetch(`/admin/api/import_requests/${id}`);
      if (!response.ok) {
        throw new Error('求人クロールリクエスト詳細の取得に失敗しました');
      }
      const data: AdminImportRequestResponse = await response.json();
      return normalizeImportRequest(data);
    },
    enabled: !!id,
  });
}
